import React from "react";
import { LabelPreview as CopperLabel } from "@/components/LabelPreview";
import { IndiaChinaLabel } from "@/components/IndiaChinaLabel";

/**
 * Returns the physical size of a sticker for a given label_type. The Print
 * page and Editor use this so a single source of truth drives every layout
 * decision (sticker preview, A4 tiling, default sizes).
 */
export function labelDimensions(labelType) {
  if (labelType === "india" || labelType === "china") {
    return { widthIn: 3, heightIn: 1.5 };
  }
  return { widthIn: 2.5, heightIn: 2.5 };
}

/**
 * Dispatches to the correct label component based on `data.label_type`.
 * Accepts sizeIn (used only for the square copper label). India / China labels
 * always render at 3 x 1.5 in but tolerate an override via widthIn/heightIn.
 */
export function StickerRenderer({ data, sizeIn, widthIn, heightIn, barcodeDataUrl }) {
  const type = data?.label_type || "copper";
  if (type === "india" || type === "china") {
    const dims = labelDimensions(type);
    return (
      <IndiaChinaLabel
        data={data}
        widthIn={widthIn || dims.widthIn}
        heightIn={heightIn || dims.heightIn}
        barcodeDataUrl={barcodeDataUrl}
      />
    );
  }
  return <CopperLabel data={data} sizeIn={sizeIn || 2.5} barcodeDataUrl={barcodeDataUrl} />;
}
